import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { PortalLayout } from "../components/portal/PortalLayout";
import { SRForm, EMPTY_SR } from "../components/portal/SRForm";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { ArrowLeft, Loader2, Send } from "lucide-react";

export default function PortalNewRequest() {
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY_SR);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!form.paziente_nominativo.trim()) return toast.error("Inserisci il nominativo del paziente");
    if (!form.data_ora_carico) return toast.error("Indica data e ora di carico");
    if (!form.destinazione_nome.trim() && !form.destinazione_indirizzo.trim()) return toast.error("Indica la struttura di destinazione");
    if (!form.mobilizzazione) return toast.error("Seleziona la mobilizzazione");
    if (!window.confirm("Inviare la richiesta? Dopo l'invio non potrà più essere modificata.")) return;
    setSaving(true);
    try {
      const { data } = await api.post("/portale/richieste", form);
      toast.success(`Richiesta ${data.code} inviata`, { description: "La Centrale Operativa la prenderà in carico a breve." });
      navigate("/strutture", { replace: true });
    } catch (err) {
      toast.error("Richiesta non inviata", { description: formatApiErrorDetail(err.response?.data?.detail) });
    } finally { setSaving(false); }
  };

  return (
    <PortalLayout>
      <Button variant="ghost" size="sm" className="gap-1 mb-3 -ml-2" onClick={() => navigate("/strutture")}><ArrowLeft className="h-4 w-4" /> Le tue richieste</Button>
      <h1 className="text-3xl font-bold font-heading text-slate-900 tracking-tight mb-1">Nuova richiesta di trasporto</h1>
      <p className="text-sm text-slate-500 mb-6">I campi con * sono obbligatori. Dopo l'invio la richiesta non è più modificabile.</p>
      <Card className="p-6 border-slate-200"><SRForm value={form} onChange={setForm} /></Card>
      <div className="flex justify-end gap-3 mt-6">
        <Button variant="outline" onClick={() => navigate("/strutture")}>Annulla</Button>
        <Button data-testid="portal-submit" onClick={submit} disabled={saving} className="gap-2 min-w-[180px]">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Send className="h-4 w-4" /> Invia richiesta</>}
        </Button>
      </div>
    </PortalLayout>
  );
}
